export default __webpack_public_path__ + "static/media/Invoice_Filled_Active.a45863ce.svg";